import { Box, Card, CardContent, Divider, Grid2, IconButton, Paper, Typography, useTheme } from '@mui/material';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { CreateProductUseCase } from '../../../Usecase/Products/create-product-usecase';

import { ListCubagesUseCase } from '../../../Usecase/Cubages/list-cubages-usecase';
import { ListProductsServiceUseCase } from '../../../Usecase/ProductsService/list-products-service-usecase';

import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { Can } from '../../../Components/Can';
import { ListCategoriesUseCase } from '../../../Usecase/Categories/list-categories-usecase';
import { ShowProductUseCase } from '../../../Usecase/Products/show-product-usecase';
import { UpdateProductUseCase } from '../../../Usecase/Products/update-product-usecase';
import { ListProductVariantsServiceUseCase } from '../../../Usecase/ProductVariants/list-product-variants-usecase';
import { ListServiceInfoOrdersUseCase } from '../../../Usecase/ServicesInfo/list-service-info-usecase';
import { useCreatePricePolicies } from './policies-price-form.hook';
import { Flex } from '../../../Components/Flex/flex.component';
import { CreatePricePoliciesUseCase } from '../../../Usecase/PricePolicies/create-price-policies-usecase';
import AddPricePolicyVariant from '../../../Components/Modals/variants/add-price-policy/add-price-policy-variant.component';
import { CreatePricePoliciesRulesUseCase } from '../../../Usecase/PricePoliciesRules/create-price-policies-rules-usecase';
import { ShowPricePoliciesUseCase } from '../../../Usecase/PricePolicies/show-price-policies-usecase';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { UpdatePricePoliciesRulesUseCase } from '../../../Usecase/PricePoliciesRules/update-price-policies-rules-usecase';
import { DestroyPricePoliciesRulesUseCase } from '../../../Usecase/PricePoliciesRules/destroy-price-policies-rules-usecase';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { UpdatePricePoliciesUseCase } from '../../../Usecase/PricePolicies/update-price-policies-usecase';



  interface IPricePoliciesProps {
    createProductUseCase: CreateProductUseCase
    listCubagesUseCase: ListCubagesUseCase
    listProductsServiceUseCase: ListProductsServiceUseCase
    listServiceInfoOrdersUseCase: ListServiceInfoOrdersUseCase
    showProductUseCase: ShowProductUseCase
    updateProductUseCase: UpdateProductUseCase
    listCategoriesUseCase: ListCategoriesUseCase
    listProductVariantsServiceUseCase: ListProductVariantsServiceUseCase
    createPricePoliciesUseCase: CreatePricePoliciesUseCase
    createPricePoliciesRulesUseCase: CreatePricePoliciesRulesUseCase
    showPricePoliciesUseCase: ShowPricePoliciesUseCase
    updatePricePoliciesRulesUseCase: UpdatePricePoliciesRulesUseCase
    destroyPricePoliciesRulesUseCase: DestroyPricePoliciesRulesUseCase
    updatePricePoliciesUseCase: UpdatePricePoliciesUseCase
  }
const PricePoliciesForm : FC<IPricePoliciesProps> = ({ createProductUseCase, listCubagesUseCase, listProductsServiceUseCase,listServiceInfoOrdersUseCase, showProductUseCase, updateProductUseCase, listCategoriesUseCase, listProductVariantsServiceUseCase, createPricePoliciesUseCase, createPricePoliciesRulesUseCase, showPricePoliciesUseCase, updatePricePoliciesRulesUseCase, destroyPricePoliciesRulesUseCase, updatePricePoliciesUseCase }) => {
   
    const theme = useTheme()
    const navigate = useNavigate()
   

    const { control, errors, handleAction, handleSubmit, loading, register, handleListCubages, handleListProductsServices, showRules, setShowRules, policies,
     

      addNewPricePolicy,
      setAddNewPricePolicy,
      policyToEdit,
      setPolicyToEdit,
      policyToDestroy,
      setPolicyToDestroy, handleAddNewRulePricePolicy, pricePoliciyId, handleClosePricePolicyModal, handleDestroyPricePolicy } = useCreatePricePolicies({
      createProductUseCase,
      listCubagesUseCase,
      listProductsServiceUseCase,
      listServiceInfoOrdersUseCase,
      showProductUseCase,
      updateProductUseCase,
      listCategoriesUseCase,
      createPricePoliciesUseCase,
      createPricePoliciesRulesUseCase,
      showPricePoliciesUseCase,
      updatePricePoliciesRulesUseCase,
      destroyPricePoliciesRulesUseCase,
      updatePricePoliciesUseCase
    })

    useEffect(() => {
      handleListCubages()
      handleListProductsServices()
      // listCategories()
    }, [])


    return (
      <Can permissions={['menu:products:manage']}>
        <BaseScreen>

          <ConfirmDialog title='Remover Regra' onCancel={() => setPolicyToDestroy(null)} description='Você tem certeza?' open={!!policyToDestroy} onConfirm={handleDestroyPricePolicy}  /> 
          
        {(addNewPricePolicy || policyToEdit?.id) && (
          <AddPricePolicyVariant data={policyToEdit || undefined} onSubmit={handleAddNewRulePricePolicy} policyId={pricePoliciyId} onClose={handleClosePricePolicyModal} />
        )}
         
          <Paper>
              <BaseContentPage 
                  title='Políticas de Preços'
                  breadcrumb={[{ title: 'Políticas de Preços', link: "/price-policies-form"}, { title: 'Nova Política de Preços'}]}
              >

                {loading ? <Loader /> : (
                  <>
                   
   
                      <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>
                        <Grid2 size={12} container spacing={2} alignItems="center">
                            <Input
                                label="Nome da Política"
                                placeholder="Preencha o nome da política"
                                error={!!errors.name}
                                helperText={errors.name?.message}
                                {...register('name')}
                            />
                        </Grid2>
                        <Grid2 size={12} container spacing={2} alignItems="center">
                            <Input
                                label="Descrição da Política"
                                placeholder="Preencha a descrição da política"
                                error={!!errors.description}
                                helperText={errors.description?.message}
                                {...register('description')}
                            />
                        </Grid2>

                      {showRules && (
                        <>
                          <Grid2 size={12} container spacing={2} alignItems="center">
                              <Flex justifyContent='space-between' width='100%' alignItems='center'>
                                <Typography sx={{fontSize: '19px', fontWeight: '600'}}>Regras da Política de Preço</Typography>
                    
                                  <Button 
                                    onClick={() => setAddNewPricePolicy(true)}
                                    variant="outlined"
                                    startIcon={<AddIcon />}
                                    sx={{ width: '270px' }}
                                  >
                                    Adicionar Regra
                                  </Button>
                              </Flex>
                            </Grid2>

                            <Divider sx={{ marginTop: '-20px', marginBottom: '0px', width: '100%' }} />
                          

                            <Grid2 size={12} container spacing={2} alignItems="center">
                              <CardContent sx={{ padding: '10px !important', width: '100%' }}>
                                {policies.length === 0 ? (
                                  <Typography sx={{ marginBottom: '20px', color: '#666' }}>
                                    Você ainda não possui nenhuma política de preço cadastrada.
                                  </Typography>
                                ) : (
                                  <>
                                    {policies.length > 1 && (
                                      <Box sx={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                                        <Typography variant="body2" sx={{ color: '#666', fontWeight: '500' }}>
                                          Resumo das políticas: {policies.length} política(s) configurada(s)
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#999' }}>
                                          Descontos aplicados de {Math.min(...policies.map(p => p.discountPercentage))}% a {Math.max(...policies.map(p => p.discountPercentage))}%
                                        </Typography>
                                      </Box>
                                    )}
                                  <Box >
                                    {policies.map((policy, index) => (
                                      <Card 
                                        key={policy.id} 
                                        sx={{ 
                                          marginBottom: '10px', 
                                          padding: '15px',
                                          border: '1px solid #e0e0e0',
                                          backgroundColor: '#fafafa'
                                        }}
                                      >
                                        <Grid2 container spacing={2} alignItems="center">
                                          <Grid2 size={4}>
                                            <Input
                                              label="Quantidade mínima"
                                              type="number"
                                              placeholder="Ex: 1000"
                                              InputProps={{ readOnly: true, disabled: true }}
                                              value={policy.minimalQuantity}
                                              onChange={() => {}}
                                              inputProps={{ min: 0, step: 1 }}
                                              error={policies.filter(p => p.minimalQuantity === policy.minimalQuantity).length > 1}
                                              helperText={policies.filter(p => p.minimalQuantity === policy.minimalQuantity).length > 1 ? 'Quantidade duplicada' : ''}
                                              sx={{ width: '100%' }}
                                            />
                                          </Grid2>
                                          <Grid2 size={4}>
                                            <Input
                                              label="Desconto (%)"
                                              type="number"
                                              placeholder="Ex: 5"
                                              value={policy.discountPercentage}
                                              InputProps={{ readOnly: true, disabled: true }}
                                              onChange={() => {}}
                                              inputProps={{ min: 0, max: 100, step: 0.1 }}
                                              sx={{ width: '100%' }}
                                            />
                                          </Grid2>
                                          <Grid2 size={3}>
                                            <Typography variant="body2" sx={{ color: '#666' }}>
                                              Se quantidade ≥ {policy.minimalQuantity || 0}, aplicar {policy.discountPercentage || 0}% de desconto
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: '#999', display: 'block', marginTop: '5px' }}>
                                              Preço final: {((100 - (policy.discountPercentage || 0)) / 100).toFixed(2)}x o preço original
                                            </Typography>
                                          </Grid2>
                                          <Grid2 size={1}>
                                            <ActionButtons params={ { row: policy }} setItemToDestroy={() => setPolicyToDestroy(policy)} editFunction={() => setPolicyToEdit(policy)} />
                                          </Grid2>
                                        </Grid2>
                                      </Card>
                                    ))}
                                  </Box>
                                  </>
                                )}
                              </CardContent>
                            </Grid2>
                        </>
                      )}

                       

                        <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading}>
                            SALVAR
                        </Button>
                      </Grid2>
                  </>
                )}

                
                  
              </BaseContentPage>
            
          </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { PricePoliciesForm };
